import { useLanguage } from '../../../context/LanguageContext';

export default function Hero() {
  const { t } = useLanguage();

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToAbout = () => {
    const element = document.getElementById('about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen w-full overflow-hidden flex items-center">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://static.readdy.ai/image/9ce25d869b896a3f5b856271bcc15d01/8e1b5dc46a926e75980580fa49746196.png')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-r from-[#0a1628]/80 via-[#0a1628]/50 to-[#0a1628]/20"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 sm:px-8 py-24 sm:py-32">
        <div className="max-w-xl lg:max-w-2xl">
          <div className="w-12 sm:w-16 h-0.5 bg-[#C9A961] mb-6 sm:mb-8"></div>
          <h1 className="text-4xl sm:text-5xl lg:text-7xl font-serif font-bold text-white leading-tight mb-6 sm:mb-8">
            {t('hero.heading')}
          </h1>
          <p className="text-base sm:text-xl text-white/90 leading-relaxed mb-8 sm:mb-12 max-w-xl">
            {t('hero.paragraph')}
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
            <button
              onClick={scrollToContact}
              className="px-6 sm:px-8 py-3 sm:py-4 bg-[#1A2B4A] text-white rounded-lg font-medium hover:bg-[#0F1A2E] transition-all flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
            >
              {t('hero.contactButton')}
              <i className="ri-arrow-right-line"></i>
            </button>
            <button
              onClick={scrollToAbout}
              className="px-6 sm:px-8 py-3 sm:py-4 border-2 border-white text-white rounded-lg font-medium hover:bg-white hover:text-[#1A2B4A] transition-all whitespace-nowrap cursor-pointer"
            >
              {t('hero.learnButton')}
            </button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <div className="w-0.5 h-10 sm:h-12 bg-white/50"></div>
        <i className="ri-arrow-down-line text-white text-xl"></i>
      </div>
    </section>
  );
}